export default __webpack_public_path__ + "static/form-one-column-dont-efcbaa5f2baa3fcd287100148223027ab8915d9cf95ab2f5ccd71e4144cf1d76.png";